import Navbar from "./Navbar";
import CampEthiccraft from "./Camps/Camps_Ethiccraft";
import ContentSlides from "./Camps/Content";
import ReviewsSection from "./Camps/Sliding_Reviews";
import PolaroidImageSlider from "./Camps/Camp_Memories";
import Footer from "./Footer";
import './Css/Camps.css'; 

function Camps() {
  return (
    <div className="camps">
      <Navbar />
      <CampEthiccraft />
      <PolaroidImageSlider />
      <ContentSlides />
      <ReviewsSection />
      <Footer />
    </div>
  );
}

export default Camps;